import { Typography } from '@euler/app/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo, useEffect, useState } from 'react';
import { aiColors } from '../../../../../ai-suite/theme';

function clock(seconds: number): string {
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${pad(Math.floor(seconds / 60))}:${pad(seconds % 60)}`;
}

/** A phone call's running timer; it stops when the call ends. */
export const CallTimer = memo(({ running }: { running: boolean }) => {
  const { rpx } = useResponsiveContext();
  const [seconds, setSeconds] = useState(0);
  useEffect(() => {
    if (!running) return;
    const timer = setInterval(() => setSeconds(s => s + 1), 1000);
    return () => clearInterval(timer);
  }, [running]);
  return (
    <Typography.Text size={rpx(13)} color={aiColors.mutedForeground}>
      {clock(seconds)}
    </Typography.Text>
  );
});
